import {
  EBrandingLevel,
  IDailyRentOfferForMobileSite,
} from '../../repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';

type TBrandingOffer = Pick<IDailyRentOfferForMobileSite, 'isHotel' | 'brandingLevel' | 'isCianPartner'>;

export const getIsBrandingBlockVisible = (offer: TBrandingOffer): boolean => {
  const isThirdLevelBranding = offer.brandingLevel === EBrandingLevel.ThirdLevel;

  return !offer.isHotel && isThirdLevelBranding;
};
